import { useContext, useEffect } from 'react';
import HomePageCategories from '../../components/homePageCategories/HomePageCategories';
import './homePage.scss';
import { AuthContext } from '../../context/AuthContext';
import BannerOne from '../../components/ads/300x250';
import BannerTwo from '../../components/ads/300x250two';
import BannerThree from '../../components/ads/300x250three';
import LatestAds from '../../components/latest/LatestAds';

function HomePage() {
  const { currentUser } = useContext(AuthContext);

  return (
    <div className="homePage">
      <div className="imgContainer">
        <HomePageCategories />
      </div>
      <div className="textContainer">
        <div className="wrapper">
          <div className="searchContent">
            <div className="featured">
              <LatestAds />
            </div>
            <div className="ads">
  <div className="bannerWrapper">
    <BannerOne />
  </div> 
              <div className="bannerWrapper">
     <BannerThree />
  </div>
  <div className="bannerWrapper">
    <BannerTwo />
  </div>         
</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;

